import { AxiosRequestHeaders } from 'axios';

export const removeNotAllowedHeader =
  (header: string) => (data: unknown, headers: AxiosRequestHeaders | undefined) => {
    if (headers) {
      if (header in headers) {
        delete headers[header];
      }

      if (typeof headers.common === 'object' && header in headers.common) {
        delete headers.common[header];
      }
    }

    return data;
  };
